/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Address,
  AiSuggestionAccepted,
  Appointment,
  BlogPost,
  BooleanResource,
  Call,
  CallLog,
  CanadaPostSearch,
  ClinicInfo,
  CommunicationNote,
  CronJobMetadata,
  EmailMultipleDocumentPayload,
  ErrorResponse,
  ForwardHelpdeskMessagePayload,
  HelpdeskMessage,
  InfoArticle,
  PatientListItem,
  Resource,
  StatisticsEvent,
  StringResource,
  StringResources,
  TimeOff,
  UserFeedback,
  UserTracking,
} from '../models';
import {
    AddressFromJSON,
    AddressToJSON,
    AiSuggestionAcceptedFromJSON,
    AiSuggestionAcceptedToJSON,
    AppointmentFromJSON,
    AppointmentToJSON,
    BlogPostFromJSON,
    BlogPostToJSON,
    BooleanResourceFromJSON,
    BooleanResourceToJSON,
    CallFromJSON,
    CallToJSON,
    CallLogFromJSON,
    CallLogToJSON,
    CanadaPostSearchFromJSON,
    CanadaPostSearchToJSON,
    ClinicInfoFromJSON,
    ClinicInfoToJSON,
    CommunicationNoteFromJSON,
    CommunicationNoteToJSON,
    CronJobMetadataFromJSON,
    CronJobMetadataToJSON,
    EmailMultipleDocumentPayloadFromJSON,
    EmailMultipleDocumentPayloadToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ForwardHelpdeskMessagePayloadFromJSON,
    ForwardHelpdeskMessagePayloadToJSON,
    HelpdeskMessageFromJSON,
    HelpdeskMessageToJSON,
    InfoArticleFromJSON,
    InfoArticleToJSON,
    PatientListItemFromJSON,
    PatientListItemToJSON,
    ResourceFromJSON,
    ResourceToJSON,
    StatisticsEventFromJSON,
    StatisticsEventToJSON,
    StringResourceFromJSON,
    StringResourceToJSON,
    StringResourcesFromJSON,
    StringResourcesToJSON,
    TimeOffFromJSON,
    TimeOffToJSON,
    UserFeedbackFromJSON,
    UserFeedbackToJSON,
    UserTrackingFromJSON,
    UserTrackingToJSON,
} from '../models';

export interface AddPatientCommunicationNoteRequest {
    id: string;
    communicationNote: CommunicationNote;
}

export interface AddPatientListItemRequest {
    patientListItem: PatientListItem;
}

export interface ArchiveHelpdeskMessageRequest {
    id: string;
}

export interface AssignHelpdeskMessageRequest {
    id: string;
    userId: string;
}

export interface BookTimeOffRequest {
    physicianId: string;
    timeOff: TimeOff;
}

export interface ClaimHelpdeskMessageRequest {
    id: string;
}

export interface DeletePublicResourceRequest {
    url: string;
}

export interface ForwardHelpdeskMessageRequest {
    id: string;
    forwardHelpdeskMessagePayload: ForwardHelpdeskMessagePayload;
}

export interface GetApidazeCallXMLRequest {
    number?: string;
    bridgeStatus?: string;
    userId?: string;
    tenantId?: string;
    userRole?: string;
    patientId?: string;
    exiting?: string;
}

export interface GetApidazeKeyRequest {
    number?: string;
    bridgeStatus?: string;
    userId?: string;
    userRole?: string;
    exiting?: string;
}

export interface GetBlogPostsRequest {
    limit?: number;
}

export interface GetCallsRequest {
    patientId: string;
}

export interface GetCronRunsRequest {
    tenantId: string;
    from?: number;
    to?: number;
}

export interface GetPatientCommunicationNotesRequest {
    id: string;
}

export interface GetPatientEmailsRequest {
    patientId: string;
}

export interface GetPhotoRequest {
    role: GetPhotoRoleEnum;
    id: string;
}

export interface GetResourceRequest {
    resource: Resource;
}

export interface GetShortUrlRequest {
    id: string;
}

export interface GetSpecificOwnClinicConfigurationRequest {
    key: GetSpecificOwnClinicConfigurationKeyEnum;
}

export interface GetStatisticsRequest {
    type?: GetStatisticsTypeEnum;
    from?: number;
    to?: number;
}

export interface GetTenantLogoRequest {
    tenantId: string;
    color: GetTenantLogoColorEnum;
}

export interface MarkHelpdeskMessageReadRequest {
    id: string;
}

export interface PostCodeInServiceAreaRequest {
    postcode: string;
}

export interface RecordAiSuggestionAcceptedRequest {
    aiSuggestionAccepted: AiSuggestionAccepted;
}

export interface RemovePatientListItemRequest {
    id: string;
}

export interface ReplyHelpdeskMessageRequest {
    id: string;
    content: string;
    attachment1?: Blob;
    attachment2?: Blob;
    attachment3?: Blob;
    attachment4?: Blob;
    attachment5?: Blob;
    attachment6?: Blob;
}

export interface RetrieveAddressRequest {
    id: string;
}

export interface RunCronJobRequest {
    jobName: string;
    tenantId?: string;
}

export interface SearchAddressRequest {
    searchText: string;
    lastId?: string;
}

export interface SearchKnowledgeBaseRequest {
    query: string;
}

export interface SendPatientEmailRequest {
    patientId: string;
    emailMultipleDocumentPayload: EmailMultipleDocumentPayload;
    documentId?: string;
}

export interface SendQuestionnaireBySMSRequest {
    id: string;
}

export interface SendUserFeedbackRequest {
    userFeedback: UserFeedback;
}

export interface SesNotificationRequest {
    body?: object;
}

export interface SetClinicInfoRequest {
    clinicInfo: ClinicInfo;
}

export interface SubmitCallLogRequest {
    callLog: CallLog;
}

export interface TrackUserRequest {
    userTracking: UserTracking;
}

export interface TransferHelpdeskMessageRequest {
    id: string;
    userId: string;
}

export interface UnQuarantineHelpdeskMessageRequest {
    id: string;
}

export interface UnarchiveHelpdeskMessageRequest {
    id: string;
}

export interface UploadPhotoRequest {
    role: UploadPhotoRoleEnum;
    id: string;
    file: Blob;
}

export interface UploadPublicResourceRequest {
    file: Blob;
}

export interface UploadTenantLogoRequest {
    tenantId: string;
    color: UploadTenantLogoColorEnum;
    file: Blob;
}

/**
 * 
 */
export class ResourceApi extends runtime.BaseAPI {

    /**
     * Adds a patient communication note (Roles: physician, admin)
     */
    async addPatientCommunicationNoteRaw(requestParameters: AddPatientCommunicationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommunicationNote>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addPatientCommunicationNote.');
        }

        if (requestParameters.communicationNote === null || requestParameters.communicationNote === undefined) {
            throw new runtime.RequiredError('CommunicationNote','Required parameter requestParameters.communicationNote was null or undefined when calling addPatientCommunicationNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/communication/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommunicationNoteToJSON(requestParameters.communicationNote),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommunicationNoteFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addPatientCommunicationNoteRequestOptionsRaw(requestParameters: AddPatientCommunicationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addPatientCommunicationNote.');
        }

        if (requestParameters.communicationNote === null || requestParameters.communicationNote === undefined) {
            throw new runtime.RequiredError('CommunicationNote','Required parameter requestParameters.communicationNote was null or undefined when calling addPatientCommunicationNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/communication/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: CommunicationNoteToJSON(requestParameters.communicationNote),
        };
        return responseConfig
    }

    /**
     * Adds a patient communication note (Roles: physician, admin)
     */
    async addPatientCommunicationNote(requestParameters: AddPatientCommunicationNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommunicationNote> {
        const response = await this.addPatientCommunicationNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a patient list item (Roles: physician, admin)
     */
    async addPatientListItemRaw(requestParameters: AddPatientListItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientListItem>> {
        if (requestParameters.patientListItem === null || requestParameters.patientListItem === undefined) {
            throw new runtime.RequiredError('PatientListItem','Required parameter requestParameters.patientListItem was null or undefined when calling addPatientListItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/patient-list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PatientListItemToJSON(requestParameters.patientListItem),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientListItemFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addPatientListItemRequestOptionsRaw(requestParameters: AddPatientListItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientListItem === null || requestParameters.patientListItem === undefined) {
            throw new runtime.RequiredError('PatientListItem','Required parameter requestParameters.patientListItem was null or undefined when calling addPatientListItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/patient-list`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PatientListItemToJSON(requestParameters.patientListItem),
        };
        return responseConfig
    }

    /**
     * Adds a patient list item (Roles: physician, admin)
     */
    async addPatientListItem(requestParameters: AddPatientListItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientListItem> {
        const response = await this.addPatientListItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Archives helpdesk messages (Roles: admin)
     */
    async archiveHelpdeskMessageRaw(requestParameters: ArchiveHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling archiveHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    archiveHelpdeskMessageRequestOptionsRaw(requestParameters: ArchiveHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling archiveHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Archives helpdesk messages (Roles: admin)
     */
    async archiveHelpdeskMessage(requestParameters: ArchiveHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.archiveHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assigns a helpdesk message to a patient (Roles: admin)
     */
    async assignHelpdeskMessageRaw(requestParameters: AssignHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignHelpdeskMessage.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling assignHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/assign/{userId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    assignHelpdeskMessageRequestOptionsRaw(requestParameters: AssignHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignHelpdeskMessage.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling assignHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/assign/{userId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Assigns a helpdesk message to a patient (Roles: admin)
     */
    async assignHelpdeskMessage(requestParameters: AssignHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.assignHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Books a time off slot for physicians (Roles: admin, physician)
     */
    async bookTimeOffRaw(requestParameters: BookTimeOffRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Appointment>> {
        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling bookTimeOff.');
        }

        if (requestParameters.timeOff === null || requestParameters.timeOff === undefined) {
            throw new runtime.RequiredError('TimeOff','Required parameter requestParameters.timeOff was null or undefined when calling bookTimeOff.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/time-off/{physicianId}`.replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TimeOffToJSON(requestParameters.timeOff),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    bookTimeOffRequestOptionsRaw(requestParameters: BookTimeOffRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.physicianId === null || requestParameters.physicianId === undefined) {
            throw new runtime.RequiredError('physicianId','Required parameter requestParameters.physicianId was null or undefined when calling bookTimeOff.');
        }

        if (requestParameters.timeOff === null || requestParameters.timeOff === undefined) {
            throw new runtime.RequiredError('TimeOff','Required parameter requestParameters.timeOff was null or undefined when calling bookTimeOff.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/time-off/{physicianId}`.replace(`{${"physicianId"}}`, encodeURIComponent(String(requestParameters.physicianId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: TimeOffToJSON(requestParameters.timeOff),
        };
        return responseConfig
    }

    /**
     * Books a time off slot for physicians (Roles: admin, physician)
     */
    async bookTimeOff(requestParameters: BookTimeOffRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Appointment> {
        const response = await this.bookTimeOffRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a helpdesk message (Roles: admin)
     */
    async claimHelpdeskMessageRaw(requestParameters: ClaimHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling claimHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/claim`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    claimHelpdeskMessageRequestOptionsRaw(requestParameters: ClaimHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling claimHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/claim`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Claims a helpdesk message (Roles: admin)
     */
    async claimHelpdeskMessage(requestParameters: ClaimHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.claimHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a public-resource by url (Roles: admin, physician)
     */
    async deletePublicResourceRaw(requestParameters: DeletePublicResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.url === null || requestParameters.url === undefined) {
            throw new runtime.RequiredError('url','Required parameter requestParameters.url was null or undefined when calling deletePublicResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/public-resource/{url}`.replace(`{${"url"}}`, encodeURIComponent(String(requestParameters.url))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deletePublicResourceRequestOptionsRaw(requestParameters: DeletePublicResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.url === null || requestParameters.url === undefined) {
            throw new runtime.RequiredError('url','Required parameter requestParameters.url was null or undefined when calling deletePublicResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/public-resource/{url}`.replace(`{${"url"}}`, encodeURIComponent(String(requestParameters.url))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Delete a public-resource by url (Roles: admin, physician)
     */
    async deletePublicResource(requestParameters: DeletePublicResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePublicResourceRaw(requestParameters, initOverrides);
    }

    /**
     * Forwards a helpdesk message to an external email (Roles: admin)
     */
    async forwardHelpdeskMessageRaw(requestParameters: ForwardHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling forwardHelpdeskMessage.');
        }

        if (requestParameters.forwardHelpdeskMessagePayload === null || requestParameters.forwardHelpdeskMessagePayload === undefined) {
            throw new runtime.RequiredError('ForwardHelpdeskMessagePayload','Required parameter requestParameters.forwardHelpdeskMessagePayload was null or undefined when calling forwardHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/forward`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForwardHelpdeskMessagePayloadToJSON(requestParameters.forwardHelpdeskMessagePayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    forwardHelpdeskMessageRequestOptionsRaw(requestParameters: ForwardHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling forwardHelpdeskMessage.');
        }

        if (requestParameters.forwardHelpdeskMessagePayload === null || requestParameters.forwardHelpdeskMessagePayload === undefined) {
            throw new runtime.RequiredError('ForwardHelpdeskMessagePayload','Required parameter requestParameters.forwardHelpdeskMessagePayload was null or undefined when calling forwardHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/forward`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ForwardHelpdeskMessagePayloadToJSON(requestParameters.forwardHelpdeskMessagePayload),
        };
        return responseConfig
    }

    /**
     * Forwards a helpdesk message to an external email (Roles: admin)
     */
    async forwardHelpdeskMessage(requestParameters: ForwardHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.forwardHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the APIDaze call XML (Roles: none)
     */
    async getApidazeCallXMLRaw(requestParameters: GetApidazeCallXMLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.number !== undefined) {
            queryParameters['number'] = requestParameters.number;
        }

        if (requestParameters.bridgeStatus !== undefined) {
            queryParameters['bridge_status'] = requestParameters.bridgeStatus;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['user_id'] = requestParameters.userId;
        }

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenant_id'] = requestParameters.tenantId;
        }

        if (requestParameters.userRole !== undefined) {
            queryParameters['user_role'] = requestParameters.userRole;
        }

        if (requestParameters.patientId !== undefined) {
            queryParameters['patient_id'] = requestParameters.patientId;
        }

        if (requestParameters.exiting !== undefined) {
            queryParameters['exiting'] = requestParameters.exiting;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/apidaze/call`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
        Request Config Getter
     */
    getApidazeCallXMLRequestOptionsRaw(requestParameters: GetApidazeCallXMLRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.number !== undefined) {
            queryParameters['number'] = requestParameters.number;
        }

        if (requestParameters.bridgeStatus !== undefined) {
            queryParameters['bridge_status'] = requestParameters.bridgeStatus;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['user_id'] = requestParameters.userId;
        }

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenant_id'] = requestParameters.tenantId;
        }

        if (requestParameters.userRole !== undefined) {
            queryParameters['user_role'] = requestParameters.userRole;
        }

        if (requestParameters.patientId !== undefined) {
            queryParameters['patient_id'] = requestParameters.patientId;
        }

        if (requestParameters.exiting !== undefined) {
            queryParameters['exiting'] = requestParameters.exiting;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/apidaze/call`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the APIDaze call XML (Roles: none)
     */
    async getApidazeCallXML(requestParameters: GetApidazeCallXMLRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getApidazeCallXMLRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the APIDaze key (Roles: physician, admin)
     */
    async getApidazeKeyRaw(requestParameters: GetApidazeKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        const queryParameters: any = {};

        if (requestParameters.number !== undefined) {
            queryParameters['number'] = requestParameters.number;
        }

        if (requestParameters.bridgeStatus !== undefined) {
            queryParameters['bridge_status'] = requestParameters.bridgeStatus;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['user_id'] = requestParameters.userId;
        }

        if (requestParameters.userRole !== undefined) {
            queryParameters['user_role'] = requestParameters.userRole;
        }

        if (requestParameters.exiting !== undefined) {
            queryParameters['exiting'] = requestParameters.exiting;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/apidaze/key`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getApidazeKeyRequestOptionsRaw(requestParameters: GetApidazeKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.number !== undefined) {
            queryParameters['number'] = requestParameters.number;
        }

        if (requestParameters.bridgeStatus !== undefined) {
            queryParameters['bridge_status'] = requestParameters.bridgeStatus;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['user_id'] = requestParameters.userId;
        }

        if (requestParameters.userRole !== undefined) {
            queryParameters['user_role'] = requestParameters.userRole;
        }

        if (requestParameters.exiting !== undefined) {
            queryParameters['exiting'] = requestParameters.exiting;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/apidaze/key`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the APIDaze key (Roles: physician, admin)
     */
    async getApidazeKey(requestParameters: GetApidazeKeyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.getApidazeKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get archived helpdesk messages (Roles: admin)
     */
    async getArchivedHelpdeskMessagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HelpdeskMessage>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/archived`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HelpdeskMessageFromJSON));
    }

    /**
        Request Config Getter
     */
    getArchivedHelpdeskMessagesRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/archived`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get archived helpdesk messages (Roles: admin)
     */
    async getArchivedHelpdeskMessages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HelpdeskMessage>> {
        const response = await this.getArchivedHelpdeskMessagesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the latest blog posts (Roles: patient)
     */
    async getBlogPostsRaw(requestParameters: GetBlogPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BlogPost>>> {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/blog/posts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlogPostFromJSON));
    }

    /**
        Request Config Getter
     */
    getBlogPostsRequestOptionsRaw(requestParameters: GetBlogPostsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/blog/posts`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the latest blog posts (Roles: patient)
     */
    async getBlogPosts(requestParameters: GetBlogPostsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BlogPost>> {
        const response = await this.getBlogPostsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets calls (Roles: admin, physician)
     */
    async getCallsRaw(requestParameters: GetCallsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Call>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getCalls.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/calls/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CallFromJSON));
    }

    /**
        Request Config Getter
     */
    getCallsRequestOptionsRaw(requestParameters: GetCallsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getCalls.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/calls/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets calls (Roles: admin, physician)
     */
    async getCalls(requestParameters: GetCallsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Call>> {
        const response = await this.getCallsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the user\'s Care& clinic\'s info (Roles: patient, physician, admin)
     */
    async getClinicInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClinicInfo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/clinic-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClinicInfoFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getClinicInfoRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/clinic-info`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the user\'s Care& clinic\'s info (Roles: patient, physician, admin)
     */
    async getClinicInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClinicInfo> {
        const response = await this.getClinicInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all Care& clinics\' info (Roles: none)
     */
    async getClinicsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClinicInfo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/clinics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClinicInfoFromJSON));
    }

    /**
        Request Config Getter
     */
    getClinicsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/clinics`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all Care& clinics\' info (Roles: none)
     */
    async getClinics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClinicInfo>> {
        const response = await this.getClinicsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets metadata for all registered cron jobs (Roles: manager)
     */
    async getCronJobsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CronJobMetadata>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/cron-jobs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CronJobMetadataFromJSON));
    }

    /**
        Request Config Getter
     */
    getCronJobsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/cron-jobs`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets metadata for all registered cron jobs (Roles: manager)
     */
    async getCronJobs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CronJobMetadata>> {
        const response = await this.getCronJobsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets cron job run logs. tenantId is required (use \'global\' for non-per-tenant jobs) (Roles: manager)
     */
    async getCronRunsRaw(requestParameters: GetCronRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StatisticsEvent>>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getCronRuns.');
        }

        const queryParameters: any = {};

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenantId'] = requestParameters.tenantId;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/cron-runs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StatisticsEventFromJSON));
    }

    /**
        Request Config Getter
     */
    getCronRunsRequestOptionsRaw(requestParameters: GetCronRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getCronRuns.');
        }

        const queryParameters: any = {};

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenantId'] = requestParameters.tenantId;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/cron-runs`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets cron job run logs. tenantId is required (use \'global\' for non-per-tenant jobs) (Roles: manager)
     */
    async getCronRuns(requestParameters: GetCronRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StatisticsEvent>> {
        const response = await this.getCronRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a patient\'s communication notes (Roles: physician, admin)
     */
    async getPatientCommunicationNotesRaw(requestParameters: GetPatientCommunicationNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommunicationNote>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPatientCommunicationNotes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/communication/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommunicationNoteFromJSON));
    }

    /**
        Request Config Getter
     */
    getPatientCommunicationNotesRequestOptionsRaw(requestParameters: GetPatientCommunicationNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPatientCommunicationNotes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/communication/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a patient\'s communication notes (Roles: physician, admin)
     */
    async getPatientCommunicationNotes(requestParameters: GetPatientCommunicationNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommunicationNote>> {
        const response = await this.getPatientCommunicationNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all patient emails (Roles: admin, physician)
     */
    async getPatientEmailsRaw(requestParameters: GetPatientEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HelpdeskMessage>>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPatientEmails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HelpdeskMessageFromJSON));
    }

    /**
        Request Config Getter
     */
    getPatientEmailsRequestOptionsRaw(requestParameters: GetPatientEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling getPatientEmails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all patient emails (Roles: admin, physician)
     */
    async getPatientEmails(requestParameters: GetPatientEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HelpdeskMessage>> {
        const response = await this.getPatientEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all patient list items (Roles: admin, physician)
     */
    async getPatientListItemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientListItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/patient-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientListItemFromJSON));
    }

    /**
        Request Config Getter
     */
    getPatientListItemsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/patient-list`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all patient list items (Roles: admin, physician)
     */
    async getPatientListItems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientListItem>> {
        const response = await this.getPatientListItemsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a profile photo (Roles: patient, physician, admin)
     */
    async getPhotoRaw(requestParameters: GetPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling getPhoto.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPhoto.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/profile-photo/{role}/{id}`.replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getPhotoRequestOptionsRaw(requestParameters: GetPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling getPhoto.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPhoto.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/profile-photo/{role}/{id}`.replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a profile photo (Roles: patient, physician, admin)
     */
    async getPhoto(requestParameters: GetPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a resource based on an URL (Roles: admin, physician)
     */
    async getResourceRaw(requestParameters: GetResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('Resource','Required parameter requestParameters.resource was null or undefined when calling getResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResourceToJSON(requestParameters.resource),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getResourceRequestOptionsRaw(requestParameters: GetResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('Resource','Required parameter requestParameters.resource was null or undefined when calling getResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ResourceToJSON(requestParameters.resource),
        };
        return responseConfig
    }

    /**
     * Gets a resource based on an URL (Roles: admin, physician)
     */
    async getResource(requestParameters: GetResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getResourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a short URL resource (Roles: none)
     */
    async getShortUrlRaw(requestParameters: GetShortUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getShortUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/url/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getShortUrlRequestOptionsRaw(requestParameters: GetShortUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getShortUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/url/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a short URL resource (Roles: none)
     */
    async getShortUrl(requestParameters: GetShortUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getShortUrlRaw(requestParameters, initOverrides);
    }

    /**
     * Gets the user\'s specific clinic configuration based on a key (Roles:  admin, physician)
     */
    async getSpecificOwnClinicConfigurationRaw(requestParameters: GetSpecificOwnClinicConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getSpecificOwnClinicConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/clinic-info/configuration/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getSpecificOwnClinicConfigurationRequestOptionsRaw(requestParameters: GetSpecificOwnClinicConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getSpecificOwnClinicConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/clinic-info/configuration/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the user\'s specific clinic configuration based on a key (Roles:  admin, physician)
     */
    async getSpecificOwnClinicConfiguration(requestParameters: GetSpecificOwnClinicConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.getSpecificOwnClinicConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all BE statistics (Roles: admin)
     */
    async getStatisticsRaw(requestParameters: GetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StatisticsEvent>>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/statistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StatisticsEventFromJSON));
    }

    /**
        Request Config Getter
     */
    getStatisticsRequestOptionsRaw(requestParameters: GetStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/statistics`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all BE statistics (Roles: admin)
     */
    async getStatistics(requestParameters: GetStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StatisticsEvent>> {
        const response = await this.getStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a tenant logo
     */
    async getTenantLogoRaw(requestParameters: GetTenantLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantLogo.');
        }

        if (requestParameters.color === null || requestParameters.color === undefined) {
            throw new runtime.RequiredError('color','Required parameter requestParameters.color was null or undefined when calling getTenantLogo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/logo/{tenantId}/{color}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))).replace(`{${"color"}}`, encodeURIComponent(String(requestParameters.color))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getTenantLogoRequestOptionsRaw(requestParameters: GetTenantLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling getTenantLogo.');
        }

        if (requestParameters.color === null || requestParameters.color === undefined) {
            throw new runtime.RequiredError('color','Required parameter requestParameters.color was null or undefined when calling getTenantLogo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/logo/{tenantId}/{color}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))).replace(`{${"color"}}`, encodeURIComponent(String(requestParameters.color))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a tenant logo
     */
    async getTenantLogo(requestParameters: GetTenantLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getTenantLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get unarchived helpdesk messages (Roles: admin)
     */
    async getUnarchivedHelpdeskMessagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HelpdeskMessage>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HelpdeskMessageFromJSON));
    }

    /**
        Request Config Getter
     */
    getUnarchivedHelpdeskMessagesRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get unarchived helpdesk messages (Roles: admin)
     */
    async getUnarchivedHelpdeskMessages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HelpdeskMessage>> {
        const response = await this.getUnarchivedHelpdeskMessagesRaw(initOverrides);
        return await response.value();
    }

    /**
     * lists public resources (Roles: admin, physician)
     */
    async listPublicResourcesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResources>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/public-resource`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourcesFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    listPublicResourcesRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/public-resource`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * lists public resources (Roles: admin, physician)
     */
    async listPublicResources(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResources> {
        const response = await this.listPublicResourcesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Marks helpdesk message read (Roles: admin)
     */
    async markHelpdeskMessageReadRaw(requestParameters: MarkHelpdeskMessageReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling markHelpdeskMessageRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/mark-read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    markHelpdeskMessageReadRequestOptionsRaw(requestParameters: MarkHelpdeskMessageReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling markHelpdeskMessageRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/mark-read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Marks helpdesk message read (Roles: admin)
     */
    async markHelpdeskMessageRead(requestParameters: MarkHelpdeskMessageReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.markHelpdeskMessageReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if postcode is included in the service area (Roles: none)
     */
    async postCodeInServiceAreaRaw(requestParameters: PostCodeInServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BooleanResource>> {
        if (requestParameters.postcode === null || requestParameters.postcode === undefined) {
            throw new runtime.RequiredError('postcode','Required parameter requestParameters.postcode was null or undefined when calling postCodeInServiceArea.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/service-area/valid/{postcode}`.replace(`{${"postcode"}}`, encodeURIComponent(String(requestParameters.postcode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BooleanResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    postCodeInServiceAreaRequestOptionsRaw(requestParameters: PostCodeInServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.postcode === null || requestParameters.postcode === undefined) {
            throw new runtime.RequiredError('postcode','Required parameter requestParameters.postcode was null or undefined when calling postCodeInServiceArea.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/service-area/valid/{postcode}`.replace(`{${"postcode"}}`, encodeURIComponent(String(requestParameters.postcode))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Checks if postcode is included in the service area (Roles: none)
     */
    async postCodeInServiceArea(requestParameters: PostCodeInServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BooleanResource> {
        const response = await this.postCodeInServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Records that a clinician accepted an AI suggestion, for usefulness metrics (Roles: physician, admin)
     */
    async recordAiSuggestionAcceptedRaw(requestParameters: RecordAiSuggestionAcceptedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsEvent>> {
        if (requestParameters.aiSuggestionAccepted === null || requestParameters.aiSuggestionAccepted === undefined) {
            throw new runtime.RequiredError('AiSuggestionAccepted','Required parameter requestParameters.aiSuggestionAccepted was null or undefined when calling recordAiSuggestionAccepted.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/ai-suggestion-accepted`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AiSuggestionAcceptedToJSON(requestParameters.aiSuggestionAccepted),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsEventFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    recordAiSuggestionAcceptedRequestOptionsRaw(requestParameters: RecordAiSuggestionAcceptedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.aiSuggestionAccepted === null || requestParameters.aiSuggestionAccepted === undefined) {
            throw new runtime.RequiredError('AiSuggestionAccepted','Required parameter requestParameters.aiSuggestionAccepted was null or undefined when calling recordAiSuggestionAccepted.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/ai-suggestion-accepted`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AiSuggestionAcceptedToJSON(requestParameters.aiSuggestionAccepted),
        };
        return responseConfig
    }

    /**
     * Records that a clinician accepted an AI suggestion, for usefulness metrics (Roles: physician, admin)
     */
    async recordAiSuggestionAccepted(requestParameters: RecordAiSuggestionAcceptedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsEvent> {
        const response = await this.recordAiSuggestionAcceptedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a patient list item (Roles: physician, admin)
     */
    async removePatientListItemRaw(requestParameters: RemovePatientListItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePatientListItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/patient-list/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    removePatientListItemRequestOptionsRaw(requestParameters: RemovePatientListItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePatientListItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/patient-list/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes a patient list item (Roles: physician, admin)
     */
    async removePatientListItem(requestParameters: RemovePatientListItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePatientListItemRaw(requestParameters, initOverrides);
    }

    /**
     * Replies to helpdesk messages (Roles: admin)
     */
    async replyHelpdeskMessageRaw(requestParameters: ReplyHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling replyHelpdeskMessage.');
        }

        if (requestParameters.content === null || requestParameters.content === undefined) {
            throw new runtime.RequiredError('content','Required parameter requestParameters.content was null or undefined when calling replyHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.content !== undefined) {
            formParams.append('content', requestParameters.content as any);
        }

        if (requestParameters.attachment1 !== undefined) {
            formParams.append('attachment1', requestParameters.attachment1 as any);
        }

        if (requestParameters.attachment2 !== undefined) {
            formParams.append('attachment2', requestParameters.attachment2 as any);
        }

        if (requestParameters.attachment3 !== undefined) {
            formParams.append('attachment3', requestParameters.attachment3 as any);
        }

        if (requestParameters.attachment4 !== undefined) {
            formParams.append('attachment4', requestParameters.attachment4 as any);
        }

        if (requestParameters.attachment5 !== undefined) {
            formParams.append('attachment5', requestParameters.attachment5 as any);
        }

        if (requestParameters.attachment6 !== undefined) {
            formParams.append('attachment6', requestParameters.attachment6 as any);
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/reply`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    replyHelpdeskMessageRequestOptionsRaw(requestParameters: ReplyHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling replyHelpdeskMessage.');
        }

        if (requestParameters.content === null || requestParameters.content === undefined) {
            throw new runtime.RequiredError('content','Required parameter requestParameters.content was null or undefined when calling replyHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.content !== undefined) {
            formParams.append('content', requestParameters.content as any);
        }

        if (requestParameters.attachment1 !== undefined) {
            formParams.append('attachment1', requestParameters.attachment1 as any);
        }

        if (requestParameters.attachment2 !== undefined) {
            formParams.append('attachment2', requestParameters.attachment2 as any);
        }

        if (requestParameters.attachment3 !== undefined) {
            formParams.append('attachment3', requestParameters.attachment3 as any);
        }

        if (requestParameters.attachment4 !== undefined) {
            formParams.append('attachment4', requestParameters.attachment4 as any);
        }

        if (requestParameters.attachment5 !== undefined) {
            formParams.append('attachment5', requestParameters.attachment5 as any);
        }

        if (requestParameters.attachment6 !== undefined) {
            formParams.append('attachment6', requestParameters.attachment6 as any);
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/reply`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Replies to helpdesk messages (Roles: admin)
     */
    async replyHelpdeskMessage(requestParameters: ReplyHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.replyHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves an address using CanadaPost (Roles: patient, physician, admin)
     */
    async retrieveAddressRaw(requestParameters: RetrieveAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling retrieveAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/address/retrieve/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    retrieveAddressRequestOptionsRaw(requestParameters: RetrieveAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling retrieveAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/address/retrieve/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Retrieves an address using CanadaPost (Roles: patient, physician, admin)
     */
    async retrieveAddress(requestParameters: RetrieveAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.retrieveAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Runs a cron job handler by name; tenantId scopes to one tenant, omit to run for all (Roles: manager)
     */
    async runCronJobRaw(requestParameters: RunCronJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.jobName === null || requestParameters.jobName === undefined) {
            throw new runtime.RequiredError('jobName','Required parameter requestParameters.jobName was null or undefined when calling runCronJob.');
        }

        const queryParameters: any = {};

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenantId'] = requestParameters.tenantId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/run-cron-job/{jobName}`.replace(`{${"jobName"}}`, encodeURIComponent(String(requestParameters.jobName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    runCronJobRequestOptionsRaw(requestParameters: RunCronJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.jobName === null || requestParameters.jobName === undefined) {
            throw new runtime.RequiredError('jobName','Required parameter requestParameters.jobName was null or undefined when calling runCronJob.');
        }

        const queryParameters: any = {};

        if (requestParameters.tenantId !== undefined) {
            queryParameters['tenantId'] = requestParameters.tenantId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/run-cron-job/{jobName}`.replace(`{${"jobName"}}`, encodeURIComponent(String(requestParameters.jobName))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Runs a cron job handler by name; tenantId scopes to one tenant, omit to run for all (Roles: manager)
     */
    async runCronJob(requestParameters: RunCronJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.runCronJobRaw(requestParameters, initOverrides);
    }

    /**
     * Searches for an address using CanadaPost (Roles: patient, physician, admin)
     */
    async searchAddressRaw(requestParameters: SearchAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CanadaPostSearch>>> {
        if (requestParameters.searchText === null || requestParameters.searchText === undefined) {
            throw new runtime.RequiredError('searchText','Required parameter requestParameters.searchText was null or undefined when calling searchAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.lastId !== undefined) {
            queryParameters['lastId'] = requestParameters.lastId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/address/search/{searchText}`.replace(`{${"searchText"}}`, encodeURIComponent(String(requestParameters.searchText))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CanadaPostSearchFromJSON));
    }

    /**
        Request Config Getter
     */
    searchAddressRequestOptionsRaw(requestParameters: SearchAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.searchText === null || requestParameters.searchText === undefined) {
            throw new runtime.RequiredError('searchText','Required parameter requestParameters.searchText was null or undefined when calling searchAddress.');
        }

        const queryParameters: any = {};

        if (requestParameters.lastId !== undefined) {
            queryParameters['lastId'] = requestParameters.lastId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/address/search/{searchText}`.replace(`{${"searchText"}}`, encodeURIComponent(String(requestParameters.searchText))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Searches for an address using CanadaPost (Roles: patient, physician, admin)
     */
    async searchAddress(requestParameters: SearchAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CanadaPostSearch>> {
        const response = await this.searchAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches the knowledge base (Roles: patient, none)
     */
    async searchKnowledgeBaseRaw(requestParameters: SearchKnowledgeBaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InfoArticle>>> {
        if (requestParameters.query === null || requestParameters.query === undefined) {
            throw new runtime.RequiredError('query','Required parameter requestParameters.query was null or undefined when calling searchKnowledgeBase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/knowledge-base/search/{query}`.replace(`{${"query"}}`, encodeURIComponent(String(requestParameters.query))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InfoArticleFromJSON));
    }

    /**
        Request Config Getter
     */
    searchKnowledgeBaseRequestOptionsRaw(requestParameters: SearchKnowledgeBaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.query === null || requestParameters.query === undefined) {
            throw new runtime.RequiredError('query','Required parameter requestParameters.query was null or undefined when calling searchKnowledgeBase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/knowledge-base/search/{query}`.replace(`{${"query"}}`, encodeURIComponent(String(requestParameters.query))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Searches the knowledge base (Roles: patient, none)
     */
    async searchKnowledgeBase(requestParameters: SearchKnowledgeBaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InfoArticle>> {
        const response = await this.searchKnowledgeBaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends en email relative to this patient (Roles: physician, admin)
     */
    async sendPatientEmailRaw(requestParameters: SendPatientEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling sendPatientEmail.');
        }

        if (requestParameters.emailMultipleDocumentPayload === null || requestParameters.emailMultipleDocumentPayload === undefined) {
            throw new runtime.RequiredError('EmailMultipleDocumentPayload','Required parameter requestParameters.emailMultipleDocumentPayload was null or undefined when calling sendPatientEmail.');
        }

        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailMultipleDocumentPayloadToJSON(requestParameters.emailMultipleDocumentPayload),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    sendPatientEmailRequestOptionsRaw(requestParameters: SendPatientEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling sendPatientEmail.');
        }

        if (requestParameters.emailMultipleDocumentPayload === null || requestParameters.emailMultipleDocumentPayload === undefined) {
            throw new runtime.RequiredError('EmailMultipleDocumentPayload','Required parameter requestParameters.emailMultipleDocumentPayload was null or undefined when calling sendPatientEmail.');
        }

        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: EmailMultipleDocumentPayloadToJSON(requestParameters.emailMultipleDocumentPayload),
        };
        return responseConfig
    }

    /**
     * Sends en email relative to this patient (Roles: physician, admin)
     */
    async sendPatientEmail(requestParameters: SendPatientEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.sendPatientEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends the questionnaire to the patient by SMS (Roles: admin)
     */
    async sendQuestionnaireBySMSRaw(requestParameters: SendQuestionnaireBySMSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendQuestionnaireBySMS.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/questionnaire-by-sms/appointment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    sendQuestionnaireBySMSRequestOptionsRaw(requestParameters: SendQuestionnaireBySMSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendQuestionnaireBySMS.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/questionnaire-by-sms/appointment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Sends the questionnaire to the patient by SMS (Roles: admin)
     */
    async sendQuestionnaireBySMS(requestParameters: SendQuestionnaireBySMSRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendQuestionnaireBySMSRaw(requestParameters, initOverrides);
    }

    /**
     * Sends a user feedback (Roles: none)
     */
    async sendUserFeedbackRaw(requestParameters: SendUserFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.userFeedback === null || requestParameters.userFeedback === undefined) {
            throw new runtime.RequiredError('UserFeedback','Required parameter requestParameters.userFeedback was null or undefined when calling sendUserFeedback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/user-feedback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserFeedbackToJSON(requestParameters.userFeedback),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    sendUserFeedbackRequestOptionsRaw(requestParameters: SendUserFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userFeedback === null || requestParameters.userFeedback === undefined) {
            throw new runtime.RequiredError('UserFeedback','Required parameter requestParameters.userFeedback was null or undefined when calling sendUserFeedback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/user-feedback`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: UserFeedbackToJSON(requestParameters.userFeedback),
        };
        return responseConfig
    }

    /**
     * Sends a user feedback (Roles: none)
     */
    async sendUserFeedback(requestParameters: SendUserFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.sendUserFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Receives SNS notifications for inbound SES emails (Roles: none)
     */
    async sesNotificationRaw(requestParameters: SesNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/ses-notification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    sesNotificationRequestOptionsRaw(requestParameters: SesNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/ses-notification`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        };
        return responseConfig
    }

    /**
     * Receives SNS notifications for inbound SES emails (Roles: none)
     */
    async sesNotification(requestParameters: SesNotificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sesNotificationRaw(requestParameters, initOverrides);
    }

    /**
     * Changes or adds a Care& clinic\'s info (Roles: admin)
     */
    async setClinicInfoRaw(requestParameters: SetClinicInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClinicInfo>> {
        if (requestParameters.clinicInfo === null || requestParameters.clinicInfo === undefined) {
            throw new runtime.RequiredError('ClinicInfo','Required parameter requestParameters.clinicInfo was null or undefined when calling setClinicInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/clinic-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClinicInfoToJSON(requestParameters.clinicInfo),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClinicInfoFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    setClinicInfoRequestOptionsRaw(requestParameters: SetClinicInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.clinicInfo === null || requestParameters.clinicInfo === undefined) {
            throw new runtime.RequiredError('ClinicInfo','Required parameter requestParameters.clinicInfo was null or undefined when calling setClinicInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/clinic-info`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ClinicInfoToJSON(requestParameters.clinicInfo),
        };
        return responseConfig
    }

    /**
     * Changes or adds a Care& clinic\'s info (Roles: admin)
     */
    async setClinicInfo(requestParameters: SetClinicInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClinicInfo> {
        const response = await this.setClinicInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submits a telemedicine call log (Roles: patient, physician, admin)
     */
    async submitCallLogRaw(requestParameters: SubmitCallLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Call>>> {
        if (requestParameters.callLog === null || requestParameters.callLog === undefined) {
            throw new runtime.RequiredError('CallLog','Required parameter requestParameters.callLog was null or undefined when calling submitCallLog.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/call-log`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CallLogToJSON(requestParameters.callLog),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CallFromJSON));
    }

    /**
        Request Config Getter
     */
    submitCallLogRequestOptionsRaw(requestParameters: SubmitCallLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.callLog === null || requestParameters.callLog === undefined) {
            throw new runtime.RequiredError('CallLog','Required parameter requestParameters.callLog was null or undefined when calling submitCallLog.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/call-log`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: CallLogToJSON(requestParameters.callLog),
        };
        return responseConfig
    }

    /**
     * Submits a telemedicine call log (Roles: patient, physician, admin)
     */
    async submitCallLog(requestParameters: SubmitCallLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Call>> {
        const response = await this.submitCallLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Track a user (Roles: none, patient)
     */
    async trackUserRaw(requestParameters: TrackUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userTracking === null || requestParameters.userTracking === undefined) {
            throw new runtime.RequiredError('UserTracking','Required parameter requestParameters.userTracking was null or undefined when calling trackUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/track`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserTrackingToJSON(requestParameters.userTracking),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    trackUserRequestOptionsRaw(requestParameters: TrackUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userTracking === null || requestParameters.userTracking === undefined) {
            throw new runtime.RequiredError('UserTracking','Required parameter requestParameters.userTracking was null or undefined when calling trackUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/track`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: UserTrackingToJSON(requestParameters.userTracking),
        };
        return responseConfig
    }

    /**
     * Track a user (Roles: none, patient)
     */
    async trackUser(requestParameters: TrackUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.trackUserRaw(requestParameters, initOverrides);
    }

    /**
     * Transfers a helpdesk message to a staff (Roles: admin)
     */
    async transferHelpdeskMessageRaw(requestParameters: TransferHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling transferHelpdeskMessage.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling transferHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/transfer/{userId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    transferHelpdeskMessageRequestOptionsRaw(requestParameters: TransferHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling transferHelpdeskMessage.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling transferHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/transfer/{userId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Transfers a helpdesk message to a staff (Roles: admin)
     */
    async transferHelpdeskMessage(requestParameters: TransferHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.transferHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Un-quarantines a Carey-email helpdesk thread, surfacing it back to the admin queue (Roles: admin)
     */
    async unQuarantineHelpdeskMessageRaw(requestParameters: UnQuarantineHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unQuarantineHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/unquarantine`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    unQuarantineHelpdeskMessageRequestOptionsRaw(requestParameters: UnQuarantineHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unQuarantineHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/unquarantine`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Un-quarantines a Carey-email helpdesk thread, surfacing it back to the admin queue (Roles: admin)
     */
    async unQuarantineHelpdeskMessage(requestParameters: UnQuarantineHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.unQuarantineHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unarchives a helpdesk messages (Roles: admin)
     */
    async unarchiveHelpdeskMessageRaw(requestParameters: UnarchiveHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HelpdeskMessage>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unarchiveHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/resource/helpdesk/{id}/unarchive`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HelpdeskMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    unarchiveHelpdeskMessageRequestOptionsRaw(requestParameters: UnarchiveHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unarchiveHelpdeskMessage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/resource/helpdesk/{id}/unarchive`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Unarchives a helpdesk messages (Roles: admin)
     */
    async unarchiveHelpdeskMessage(requestParameters: UnarchiveHelpdeskMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HelpdeskMessage> {
        const response = await this.unarchiveHelpdeskMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a profile photo in JPEG format (Roles: patient, physician, admin)
     */
    async uploadPhotoRaw(requestParameters: UploadPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Resource>> {
        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling uploadPhoto.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling uploadPhoto.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadPhoto.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/resource/profile-photo/{role}/{id}`.replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    uploadPhotoRequestOptionsRaw(requestParameters: UploadPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling uploadPhoto.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling uploadPhoto.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadPhoto.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }


        const responseConfig = {
            path: `/resource/profile-photo/{role}/{id}`.replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Upload a profile photo in JPEG format (Roles: patient, physician, admin)
     */
    async uploadPhoto(requestParameters: UploadPhotoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Resource> {
        const response = await this.uploadPhotoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a public resource (Roles: patient, physician, admin)
     */
    async uploadPublicResourceRaw(requestParameters: UploadPublicResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadPublicResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/public-resource`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    uploadPublicResourceRequestOptionsRaw(requestParameters: UploadPublicResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadPublicResource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }


        const responseConfig = {
            path: `/public-resource`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Upload a public resource (Roles: patient, physician, admin)
     */
    async uploadPublicResource(requestParameters: UploadPublicResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.uploadPublicResourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload the logo (Roles: manager)
     */
    async uploadTenantLogoRaw(requestParameters: UploadTenantLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Resource>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling uploadTenantLogo.');
        }

        if (requestParameters.color === null || requestParameters.color === undefined) {
            throw new runtime.RequiredError('color','Required parameter requestParameters.color was null or undefined when calling uploadTenantLogo.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadTenantLogo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/resource/logo/{tenantId}/{color}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))).replace(`{${"color"}}`, encodeURIComponent(String(requestParameters.color))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    uploadTenantLogoRequestOptionsRaw(requestParameters: UploadTenantLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling uploadTenantLogo.');
        }

        if (requestParameters.color === null || requestParameters.color === undefined) {
            throw new runtime.RequiredError('color','Required parameter requestParameters.color was null or undefined when calling uploadTenantLogo.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadTenantLogo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }


        const responseConfig = {
            path: `/resource/logo/{tenantId}/{color}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))).replace(`{${"color"}}`, encodeURIComponent(String(requestParameters.color))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Upload the logo (Roles: manager)
     */
    async uploadTenantLogo(requestParameters: UploadTenantLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Resource> {
        const response = await this.uploadTenantLogoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetPhotoRoleEnum = {
    Physician: 'physician',
    Patient: 'patient',
    Admin: 'admin',
    Phlebotomist: 'phlebotomist'
} as const;
export type GetPhotoRoleEnum = typeof GetPhotoRoleEnum[keyof typeof GetPhotoRoleEnum];
/**
 * @export
 */
export const GetSpecificOwnClinicConfigurationKeyEnum = {
    LifelabsContract: 'lifelabs_contract'
} as const;
export type GetSpecificOwnClinicConfigurationKeyEnum = typeof GetSpecificOwnClinicConfigurationKeyEnum[keyof typeof GetSpecificOwnClinicConfigurationKeyEnum];
/**
 * @export
 */
export const GetStatisticsTypeEnum = {
    Unsubscription: 'unsubscription',
    Subscription: 'subscription',
    UnsubscriptionPaymentFailed: 'unsubscription-payment_failed',
    ClinicChange: 'clinic-change',
    AppointmentAttempt: 'appointment_attempt',
    SubscriptionRenewal: 'subscription-renewal',
    SubscriberCountClinic: 'subscriber-count-clinic',
    SubscriberCount: 'subscriber-count',
    Session: 'session',
    PaidAppointment: 'paid-appointment',
    ReferralCodeUsed: 'referral-code-used',
    SesEmailStats: 'ses-email-stats',
    NotificationStats: 'notification-stats',
    SmsStats: 'sms-stats',
    Hl7Stats: 'hl7-stats',
    TenantHealthSnapshot: 'tenant-health-snapshot',
    AiSuggestionAccepted: 'ai-suggestion-accepted'
} as const;
export type GetStatisticsTypeEnum = typeof GetStatisticsTypeEnum[keyof typeof GetStatisticsTypeEnum];
/**
 * @export
 */
export const GetTenantLogoColorEnum = {
    DefaultColor: 'default_color',
    DefaultWhite: 'default_white',
    FullColor: 'full_color',
    FullWhite: 'full_white',
    IconColor: 'icon_color',
    IconWhite: 'icon_white',
    Favicon: 'favicon',
    LandingPageImage: 'landing_page_image'
} as const;
export type GetTenantLogoColorEnum = typeof GetTenantLogoColorEnum[keyof typeof GetTenantLogoColorEnum];
/**
 * @export
 */
export const UploadPhotoRoleEnum = {
    Physician: 'physician',
    Patient: 'patient',
    Admin: 'admin'
} as const;
export type UploadPhotoRoleEnum = typeof UploadPhotoRoleEnum[keyof typeof UploadPhotoRoleEnum];
/**
 * @export
 */
export const UploadTenantLogoColorEnum = {
    DefaultColor: 'default_color',
    DefaultWhite: 'default_white',
    FullColor: 'full_color',
    FullWhite: 'full_white',
    IconColor: 'icon_color',
    IconWhite: 'icon_white',
    Favicon: 'favicon',
    LandingPageImage: 'landing_page_image'
} as const;
export type UploadTenantLogoColorEnum = typeof UploadTenantLogoColorEnum[keyof typeof UploadTenantLogoColorEnum];
